import { InProductTrialTypeEnum } from '@nirvana/shared/dtos/types/in-product-trials';
import { AvailableProductTrialType } from '../../types/AvailableProductTrialType';

export enum InProductTrialsOverlayWindowGroupId {
  NewSection,
  ReadyToTry,
  TrialEnded,
}

export enum InProductTrialsOverlayWindowType {
  // new section
  ProductTrialsHubNewSection = 'overlayWindowProductTrialsHubNewSection',
  // ready to try
  OfficeSecurityPackReadyToTry = 'officePackReadyToTry',
  NextGenIncidentsReadyToTry = 'nextGenIncidentsReadyToTry',
  NextGenWithReconfigureReadyToTry = 'nextGenWithReconfigureReadyToTry',
  AtdIncidentsReadyToTry = 'atdIncidentsReadyToTry',
  PatchManagementNetworkReadyToTry = 'patchNetworkReadyToTry',
  VolumeEncryptionNetworkReadyToTry = 'encryptionNetworkReadyToTry',
  MobileSecurityMobileReadyToTry = 'mobileMobileReadyToTry',
  IntegrityMonitorReadyToTry = 'integrityReadyToTry',
  ContainerProtectionReadyToTry = 'containerReadyToTry',
  StorageProtectionReadyToTry = 'storageReadyToTry',
  XdrFullReadyToTry = 'xdrFullReadyToTry',
  XdrSensorsReadyToTry = 'xdrSensorsReadyToTry',
  NadAndEraReadyToTry = 'nadAndEraReadyToTry',
  WebAccessAndDeviceControlReadyToTry = 'webAccessAndDeviceControlReadyToTry',

  // trial ended
  OfficeSecurityPackTrialEnded = 'officePackTrialEnded',
  NextGenTrialEnded = 'nextGenTrialEnded',
  NextGenWithReconfigureTrialEnded = 'nextGenWithReconfigureTrialEnded',
  AtdTrialEnded = 'atdTrialEnded',
  PatchManagementTrialEnded = 'patchTrialEnded',
  VolumeEncryptionTrialEnded = 'encryptionTrialEnded',
  MobileSecurityTrialEnded = 'mobileTrialEnded',
  IntegrityMonitorTrialEnded = 'integrityTrialEnded',
  ContainerProtectionTrialEnded = 'containerTrialEnded',
  StorageProtectionTrialEnded = 'storageTrialEnded',
  XdrFullTrialEnded = 'xdrFullTrialEnded',
  XdrSensorsTrialEnded = 'xdrSensorsTrialEnded',
  NadAndEraTrialEnded = 'nadAndEraTrialEnded',
  WebAccessAndDeviceControlTrialEnded = 'webAccessAndDeviceControlTrialEnded',
}

export const InProductTrialsOverlayWindowTypesByGroupId: {
  [groupId in InProductTrialsOverlayWindowGroupId]: Array<InProductTrialsOverlayWindowType>;
} = {
  [InProductTrialsOverlayWindowGroupId.NewSection]: [InProductTrialsOverlayWindowType.ProductTrialsHubNewSection],
  [InProductTrialsOverlayWindowGroupId.ReadyToTry]: [
    InProductTrialsOverlayWindowType.OfficeSecurityPackReadyToTry,
    InProductTrialsOverlayWindowType.NextGenIncidentsReadyToTry,
    InProductTrialsOverlayWindowType.NextGenWithReconfigureReadyToTry,
    InProductTrialsOverlayWindowType.AtdIncidentsReadyToTry,
    InProductTrialsOverlayWindowType.PatchManagementNetworkReadyToTry,
    InProductTrialsOverlayWindowType.VolumeEncryptionNetworkReadyToTry,
    InProductTrialsOverlayWindowType.MobileSecurityMobileReadyToTry,
    InProductTrialsOverlayWindowType.IntegrityMonitorReadyToTry,
    InProductTrialsOverlayWindowType.ContainerProtectionReadyToTry,
    InProductTrialsOverlayWindowType.StorageProtectionReadyToTry,
    InProductTrialsOverlayWindowType.XdrFullReadyToTry,
    InProductTrialsOverlayWindowType.XdrSensorsReadyToTry,
    InProductTrialsOverlayWindowType.NadAndEraReadyToTry,
    InProductTrialsOverlayWindowType.WebAccessAndDeviceControlReadyToTry,
  ],
  [InProductTrialsOverlayWindowGroupId.TrialEnded]: [
    InProductTrialsOverlayWindowType.OfficeSecurityPackTrialEnded,
    InProductTrialsOverlayWindowType.NextGenTrialEnded,
    InProductTrialsOverlayWindowType.NextGenWithReconfigureTrialEnded,
    InProductTrialsOverlayWindowType.AtdTrialEnded,
    InProductTrialsOverlayWindowType.PatchManagementTrialEnded,
    InProductTrialsOverlayWindowType.VolumeEncryptionTrialEnded,
    InProductTrialsOverlayWindowType.MobileSecurityTrialEnded,
    InProductTrialsOverlayWindowType.IntegrityMonitorTrialEnded,
    InProductTrialsOverlayWindowType.ContainerProtectionTrialEnded,
    InProductTrialsOverlayWindowType.StorageProtectionTrialEnded,
    InProductTrialsOverlayWindowType.XdrFullTrialEnded,
    InProductTrialsOverlayWindowType.XdrSensorsTrialEnded,
    InProductTrialsOverlayWindowType.NadAndEraTrialEnded,
    InProductTrialsOverlayWindowType.WebAccessAndDeviceControlTrialEnded,
  ],
};

export const InProductTrialsOverlayWindowTypesToTrialType: {
  [type in InProductTrialsOverlayWindowType]: AvailableProductTrialType | null;
} = {
  // new section
  [InProductTrialsOverlayWindowType.ProductTrialsHubNewSection]: null,

  // ready to try
  [InProductTrialsOverlayWindowType.OfficeSecurityPackReadyToTry]: InProductTrialTypeEnum.OfficeSecurityPack,
  [InProductTrialsOverlayWindowType.NextGenIncidentsReadyToTry]: InProductTrialTypeEnum.NextGen,
  [InProductTrialsOverlayWindowType.NextGenWithReconfigureReadyToTry]:
    InProductTrialTypeEnum.NextGenWithReconfigurePopup,
  [InProductTrialsOverlayWindowType.AtdIncidentsReadyToTry]: InProductTrialTypeEnum.Atd,
  [InProductTrialsOverlayWindowType.PatchManagementNetworkReadyToTry]: InProductTrialTypeEnum.PatchManagement,
  [InProductTrialsOverlayWindowType.VolumeEncryptionNetworkReadyToTry]: InProductTrialTypeEnum.VolumeEncryption,
  [InProductTrialsOverlayWindowType.MobileSecurityMobileReadyToTry]: InProductTrialTypeEnum.MobileSecurity,
  [InProductTrialsOverlayWindowType.IntegrityMonitorReadyToTry]: InProductTrialTypeEnum.IntegrityMonitor,
  [InProductTrialsOverlayWindowType.ContainerProtectionReadyToTry]: InProductTrialTypeEnum.ContainerProtection,
  [InProductTrialsOverlayWindowType.StorageProtectionReadyToTry]: InProductTrialTypeEnum.StorageProtection,
  [InProductTrialsOverlayWindowType.XdrFullReadyToTry]: InProductTrialTypeEnum.XdrFull,
  [InProductTrialsOverlayWindowType.XdrSensorsReadyToTry]: InProductTrialTypeEnum.XdrSensors,
  [InProductTrialsOverlayWindowType.NadAndEraReadyToTry]: InProductTrialTypeEnum.NadAndEraAddon,
  [InProductTrialsOverlayWindowType.WebAccessAndDeviceControlReadyToTry]:
    InProductTrialTypeEnum.WebAccessAndDeviceControlAddon,

  // trial ended
  [InProductTrialsOverlayWindowType.OfficeSecurityPackTrialEnded]: InProductTrialTypeEnum.OfficeSecurityPack,
  [InProductTrialsOverlayWindowType.NextGenTrialEnded]: InProductTrialTypeEnum.NextGen,
  [InProductTrialsOverlayWindowType.NextGenWithReconfigureTrialEnded]:
    InProductTrialTypeEnum.NextGenWithReconfigurePopup,
  [InProductTrialsOverlayWindowType.AtdTrialEnded]: InProductTrialTypeEnum.Atd,
  [InProductTrialsOverlayWindowType.PatchManagementTrialEnded]: InProductTrialTypeEnum.PatchManagement,
  [InProductTrialsOverlayWindowType.VolumeEncryptionTrialEnded]: InProductTrialTypeEnum.VolumeEncryption,
  [InProductTrialsOverlayWindowType.MobileSecurityTrialEnded]: InProductTrialTypeEnum.MobileSecurity,
  [InProductTrialsOverlayWindowType.IntegrityMonitorTrialEnded]: InProductTrialTypeEnum.IntegrityMonitor,
  [InProductTrialsOverlayWindowType.ContainerProtectionTrialEnded]: InProductTrialTypeEnum.ContainerProtection,
  [InProductTrialsOverlayWindowType.StorageProtectionTrialEnded]: InProductTrialTypeEnum.StorageProtection,
  [InProductTrialsOverlayWindowType.XdrFullTrialEnded]: InProductTrialTypeEnum.XdrFull,
  [InProductTrialsOverlayWindowType.XdrSensorsTrialEnded]: InProductTrialTypeEnum.XdrSensors,
  [InProductTrialsOverlayWindowType.NadAndEraTrialEnded]: InProductTrialTypeEnum.NadAndEraAddon,
  [InProductTrialsOverlayWindowType.WebAccessAndDeviceControlTrialEnded]:
    InProductTrialTypeEnum.WebAccessAndDeviceControlAddon,
};

// ready to try section
export type InProductTrialsOverlayWindowReadyToTryType =
  | InProductTrialsOverlayWindowType.OfficeSecurityPackReadyToTry
  | InProductTrialsOverlayWindowType.NextGenIncidentsReadyToTry
  | InProductTrialsOverlayWindowType.NextGenWithReconfigureReadyToTry
  | InProductTrialsOverlayWindowType.AtdIncidentsReadyToTry
  | InProductTrialsOverlayWindowType.PatchManagementNetworkReadyToTry
  | InProductTrialsOverlayWindowType.VolumeEncryptionNetworkReadyToTry
  | InProductTrialsOverlayWindowType.MobileSecurityMobileReadyToTry
  | InProductTrialsOverlayWindowType.IntegrityMonitorReadyToTry
  | InProductTrialsOverlayWindowType.ContainerProtectionReadyToTry
  | InProductTrialsOverlayWindowType.StorageProtectionReadyToTry
  | InProductTrialsOverlayWindowType.XdrFullReadyToTry
  | InProductTrialsOverlayWindowType.XdrSensorsReadyToTry
  | InProductTrialsOverlayWindowType.NadAndEraReadyToTry
  | InProductTrialsOverlayWindowType.WebAccessAndDeviceControlReadyToTry;

// trial ended section
export type InProductTrialsOverlayWindowTrialEndedType =
  | InProductTrialsOverlayWindowType.OfficeSecurityPackTrialEnded
  | InProductTrialsOverlayWindowType.NextGenTrialEnded
  | InProductTrialsOverlayWindowType.NextGenWithReconfigureTrialEnded
  | InProductTrialsOverlayWindowType.AtdTrialEnded
  | InProductTrialsOverlayWindowType.PatchManagementTrialEnded
  | InProductTrialsOverlayWindowType.VolumeEncryptionTrialEnded
  | InProductTrialsOverlayWindowType.MobileSecurityTrialEnded
  | InProductTrialsOverlayWindowType.IntegrityMonitorTrialEnded
  | InProductTrialsOverlayWindowType.ContainerProtectionTrialEnded
  | InProductTrialsOverlayWindowType.StorageProtectionTrialEnded
  | InProductTrialsOverlayWindowType.XdrFullTrialEnded
  | InProductTrialsOverlayWindowType.XdrSensorsTrialEnded
  | InProductTrialsOverlayWindowType.NadAndEraTrialEnded
  | InProductTrialsOverlayWindowType.WebAccessAndDeviceControlTrialEnded;
